import classnames from 'classnames';
import { useId } from 'react';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  rarity: Rarity | 'mix';
  size?: Unit;
  className?: string;
  cardSet?: string;
};
export const ScarcityIcon = ({
  rarity,
  size = 2,
  className,
  cardSet,
}: Props) => {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2 0 12 16"
      fill="none"
      style={{ height: unitMapping[size], aspectRatio: 0.75 }}
      className={classnames('rarity-colored', rarity, cardSet, className)}
    >
      <path
        d="M3.35315 0.400391H12.6471C12.9524 0.400391 13.1998 0.647831 13.1998 0.953125V12.5566C13.1998 12.7104 13.1358 12.8573 13.0231 12.9619L10.3356 15.4531C10.2334 15.5477 10.0988 15.5996 9.95959 15.5996H3.35315C3.04786 15.5996 2.80042 15.3522 2.80042 15.0469V0.953125C2.80042 0.647832 3.04786 0.400391 3.35315 0.400391Z"
        fill={`url(#fill-${id})`}
        stroke={`url(#stroke-${id})`}
        strokeWidth="0.8"
      />
      <path
        d="M13.6 8.14812C13.6 7.91017 13.5192 7.59073 13.1948 7.49772C12.9794 7.40513 11.131 6.73899 10.2337 6.41749C10.1487 6.36878 9.97432 6.16627 9.83471 6.00415C9.75319 5.9095 9.68354 5.82862 9.65046 5.80016C9.57868 5.73839 9.59064 5.10575 9.6056 4.79715C9.62056 4.60425 9.69533 4.33414 9.69533 4.33414C10.1888 4.17988 10.2337 3.44687 10.2337 3.44687C10.3414 3.0765 10.0094 3.06107 9.87479 3.21533L9.87479 2.67528C9.87479 2.64441 9.81497 2.1223 9.78506 1.86511C9.78506 1.42787 9.20182 0.707719 7.99047 0.59198C6.5548 0.622844 6.13607 1.45359 6.10616 1.86511L6.10616 2.6367L6.15102 3.21533C6.03138 2.99671 5.7921 3.09965 5.7921 3.40823C5.7921 4.08723 6.18093 4.30842 6.37534 4.33414C6.43516 4.4756 6.56378 4.79709 6.59967 4.95141C6.63556 5.10573 6.58471 5.58154 6.5548 5.80016L6.19589 6.37886C5.40328 6.63605 3.69244 7.18902 3.18995 7.34334C2.68747 7.49766 2.55539 8.14767 2.43575 8.36629L2.40023 8.97242L2.40023 8.92464C2.40023 9.47866 2.39977 10.9525 2.40023 12.0875C2.40069 13.2226 7.99047 12.0875 7.99047 12.0875H13.6C13.6 10.8505 13.6 9.47866 13.6 8.92464L13.6 8.14812Z"
        fill={`url(#fill-player-${id})`}
        stroke="white"
        strokeOpacity="0.07"
        strokeWidth="0.172249"
      />
      <defs>
        <linearGradient
          id={`fill-${id}`}
          x1="8.00002"
          y1="0"
          x2="8.00002"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--rarity-primary)" />
          <stop offset="1" stopColor="var(--rarity-secondary)" />
        </linearGradient>
        <linearGradient
          id={`stroke-${id}`}
          x1="12.539"
          y1="18"
          x2="4.75617"
          y2="10.7067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--rarity-stroke-from)" />
          <stop offset="1" stopColor="var(--rarity-stroke-to)" />
        </linearGradient>
        <linearGradient
          id={`fill-player-${id}`}
          x1="8.00002"
          y1="-0.505196"
          x2="8.00002"
          y2="12.0875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--rarity-tertiary)" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
